import { useMutation } from 'react-query'

import { searchArticle } from '../../endpoints/howTo'

export const useGetSearchArticle = () => {
    return useMutation(
        async ({ query, category }: { query: string; category: string }) =>
            await searchArticle({ query, category })
    )
}
